const stroke = '#959AA4';

export function InfoIcon() {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1_744)">
        <path
          d="M3.1001 10C3.1001 10.9849 3.29409 11.9602 3.671 12.8701C4.04791 13.7801 4.60036 14.6069 5.2968 15.3033C5.99324 15.9997 6.82003 16.5522 7.72997 16.9291C8.63991 17.306 9.61518 17.5 10.6001 17.5C11.585 17.5 12.5603 17.306 13.4702 16.9291C14.3802 16.5522 15.207 15.9997 15.9034 15.3033C16.5998 14.6069 17.1523 13.7801 17.5292 12.8701C17.9061 11.9602 18.1001 10.9849 18.1001 10C18.1001 8.01088 17.3099 6.10322 15.9034 4.6967C14.4969 3.29018 12.5892 2.5 10.6001 2.5C8.61097 2.5 6.70332 3.29018 5.2968 4.6967C3.89027 6.10322 3.1001 8.01088 3.1001 10Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10.6001 7.5H10.6084" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.76611 10H10.5994V13.3333H11.4328" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1_744">
          <rect width="20" height="20" fill="white" transform="translate(0.600098)" />
        </clipPath>
      </defs>
    </svg>
  );
}
